import React, { useEffect, useState } from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useBroadcast } from '../../Data/Broadcasts';
import { useParams } from 'react-router-dom';
import { PageLoading } from '../../Components/Loading';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';
import Details from './Details';
import Customers from './Customers';
import Template from './Template';
import { usePreference } from '../../Data/Preference';
import AddEditBroadcast from '../Broadcasts/AddEditBroadcast';

let timeout;

const waits = {
    // Draft: 5000,
    // Ready: 5000,
    // Scheduled: 5000,
    Sending: 1000,
    Sent: 5000,
    // Archived: 5000,
}

const Broadcast = () => {
    const {broadcastId} = useParams();
    const {broadcast, selectRecipients, send, refresh, update} = useBroadcast(broadcastId, true);
    const [isUpdating, setIsUpdating] = useState(false);

    const refresher = async () => {
        const b = await refresh();

        clearTimeout(timeout);
        timeout = setTimeout(() => refresher(), waits[b.status] ?? 10000);
    }

    useEffect(() => {
        if (!broadcast) {
            return;
        }

        clearTimeout(timeout);
        timeout = setTimeout(() => refresher(), waits[broadcast?.status] ?? 10000);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [broadcast?.status]);

    return <>
        <TopBar left="/manage/broadcasts"
            title={broadcast ? broadcast.title : 'Broadcast'}
            dropdownOptions={[
                {
                    title: 'Update broadcast',
                    icon: 'Pencil',
                    onClick: () => setIsUpdating(true),
                    disabled: !['Draft', 'Ready'].includes(broadcast?.status),
                }
            ]}
        />
        <Page>
            {broadcast ? <Inner {...{broadcast, selectRecipients, send}} /> : <PageLoading />}
        </Page>

        <AddEditBroadcast isOpen={isUpdating}
            setIsOpen={setIsUpdating}
            broadcast={broadcast}
            save={update}
        />
    </>
}

const Inner = ({broadcast, selectRecipients, send}) => {
    const [tab, setTab] = usePreference('broadcastTab', 'Details');

    return <Tabs selected={tab} onChange={setTab}>
        <Tab title="Details">
            <Details {...{broadcast, send}} />
        </Tab>
        <Tab title="Customers">
            <Customers {...{broadcast, selectRecipients}} />
        </Tab>
        <Tab title="Template">
            <Template {...{broadcast}} />
        </Tab>
    </Tabs>
}

export default Broadcast;